import React, { useState, useEffect } from 'react';
import { sendMail, sendNotification, sendBoth } from '../../api/notifications';
import { getUsers } from '../../api/users';
import { Icon } from '@iconify/react';
import toast from 'react-hot-toast';
import { useLoader } from '../../context/LoaderContext';

const BildirimMailGonder = () => {
    const { showLoader, hideLoader } = useLoader();
    const [formData, setFormData] = useState({
        userId: 0,
        title: '',
        body: '',
    });
    const [sendType, setSendType] = useState('mail'); // 'mail', 'notification', 'both'
    const [loading, setLoading] = useState(false);
    const [isAllUsers, setIsAllUsers] = useState(true);
    const [users, setUsers] = useState([]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        if (!isAllUsers && users.length === 0) {
            fetchUsersSync();
        }
    }, [isAllUsers]);

    const fetchUsersSync = async () => {
        try {
            const res = await getUsers();
            if (res.isTrue) {
                setUsers(res.data);
            }
        } catch (error) {
            toast.error("Kullanıcılar yüklenemedi.");
        }
    };

    const handleUserToggle = (e) => {
        setIsAllUsers(e.target.checked);
        if (e.target.checked) {
            setFormData(prev => ({ ...prev, userId: 0 }));
        }
    };

    const insertEmoji = (field, emoji) => {
        setFormData(prev => ({
            ...prev,
            [field]: prev[field] + emoji
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.title || !formData.body) {
            toast.error("Başlık ve İçerik alanları zorunludur.");
            return;
        }

        if (!isAllUsers && (!formData.userId || formData.userId <= 0)) {
            toast.error("Lütfen geçerli bir Kullanıcı ID girin veya 'Tüm Kullanıcılar' seçeneğini işaretleyin.");
            return;
        }

        showLoader();
        setLoading(true);

        try {
            let res;
            if (sendType === 'mail') {
                res = await sendMail(formData);
            } else if (sendType === 'notification') {
                res = await sendNotification(formData);
            } else if (sendType === 'both') {
                res = await sendBoth(formData);
            }

            toast.success(res.message || "İşlem başarılı!");
            // Formu temizle
            setFormData({ userId: 0, title: '', body: '' });
            setIsAllUsers(true);
        } catch (error) {
            console.error("Gönderim hatası:", error);
            toast.error(error.message || "Gönderim sırasında hata oluştu.");
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-header border-bottom bg-base py-16 px-24">
                <h6 className="text-lg fw-semibold mb-0">Bildirim ve Mail Gönderimi</h6>
            </div>
            <div className="card-body p-24">
                <form onSubmit={handleSubmit}>
                    <div className="row g-4">

                        {/* Gönderim Tipi Seçimi */}
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light">Gönderim Tipi</label>
                            <div className="d-flex align-items-center gap-4 flex-wrap">
                                <div className="form-check style-check d-flex align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="sendType"
                                        id="typeMail"
                                        checked={sendType === 'mail'}
                                        onChange={() => setSendType('mail')}
                                    />
                                    <label className="form-check-label" htmlFor="typeMail">
                                        <span className="d-flex align-items-center gap-2 text-secondary-light">
                                            <Icon icon="heroicons:envelope" className="text-xl" /> Sadece Mail
                                        </span>
                                    </label>
                                </div>
                                <div className="form-check style-check d-flex align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="sendType"
                                        id="typeNotification"
                                        checked={sendType === 'notification'}
                                        onChange={() => setSendType('notification')}
                                    />
                                    <label className="form-check-label" htmlFor="typeNotification">
                                        <span className="d-flex align-items-center gap-2 text-secondary-light">
                                            <Icon icon="heroicons:bell" className="text-xl" /> Sadece Bildirim
                                        </span>
                                    </label>
                                </div>
                                <div className="form-check style-check d-flex align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="sendType"
                                        id="typeBoth"
                                        checked={sendType === 'both'}
                                        onChange={() => setSendType('both')}
                                    />
                                    <label className="form-check-label" htmlFor="typeBoth">
                                        <span className="d-flex align-items-center gap-2 text-secondary-light">
                                            <Icon icon="heroicons:paper-airplane" className="text-xl" /> Her İkisi
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Hedef Kitle */}
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <label className="form-label fw-semibold text-primary-light mb-0">Hedef Kullanıcı</label>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input cursor-pointer"
                                        type="checkbox"
                                        role="switch"
                                        id="allUsersSwitch"
                                        checked={isAllUsers}
                                        onChange={handleUserToggle}
                                    />
                                    <label className="form-check-label text-secondary-light text-sm" htmlFor="allUsersSwitch">
                                        {isAllUsers ? 'Tüm Kullanıcılara Gönder' : 'Belirli Bir Kullanıcıya Gönder'}
                                    </label>
                                </div>
                            </div>

                            {!isAllUsers && (
                                <select
                                    className="form-select radius-8"
                                    name="userId"
                                    value={formData.userId}
                                    onChange={handleChange}
                                >
                                    <option value="0">Kullanıcı Seçiniz...</option>
                                    {users.map(user => (
                                        <option key={user.id} value={user.id}>
                                            ({user.id}) {user.name} {user.surname} ( {user.email} ) ( {user.isPremium ? 'Premium' : 'Normal'} )
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>

                        {/* Başlık */}
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light d-flex justify-content-between align-items-center">
                                Başlık
                                <div className="d-flex gap-2">
                                    <button type="button" onClick={() => insertEmoji('title', '🔔')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Zil">🔔</button>
                                    <button type="button" onClick={() => insertEmoji('title', '🎁')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Hediye">🎁</button>
                                    <button type="button" onClick={() => insertEmoji('title', '⭐')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Yıldız">⭐</button>
                                    <button type="button" onClick={() => insertEmoji('title', '📢')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Duyuru">📢</button>
                                </div>
                            </label>
                            <input
                                type="text"
                                className="form-control radius-8"
                                name="title"
                                placeholder="Konu başlığı (Emoji ekleyebilirsiniz...)"
                                value={formData.title}
                                onChange={handleChange}
                            />
                        </div>

                        {/* İçerik */}
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light d-flex justify-content-between align-items-center">
                                İçerik (Mesaj)
                                <div className="d-flex gap-2">
                                    <button type="button" onClick={() => insertEmoji('body', '✨')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Işıltı">✨</button>
                                    <button type="button" onClick={() => insertEmoji('body', '🔥')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Ateş">🔥</button>
                                    <button type="button" onClick={() => insertEmoji('body', '❤️')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Kalp">❤️</button>
                                    <button type="button" onClick={() => insertEmoji('body', '✅')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Tamam">✅</button>
                                    <button type="button" onClick={() => insertEmoji('body', '🚀')} className="btn btn-sm btn-outline-info px-2 py-1 radius-4" title="Roket">🚀</button>
                                </div>
                            </label>
                            <textarea
                                className="form-control radius-8"
                                rows="5"
                                name="body"
                                placeholder="Mesaj içeriği (Emoji ekleyebilirsiniz...)"
                                value={formData.body}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        {/* Buton */}
                        <div className="col-12 d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-primary-600 radius-8 px-24 py-12 d-flex align-items-center gap-2"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <Icon icon="line-md:loading-loop" className="text-xl" /> Gönderiliyor...
                                    </>
                                ) : (
                                    <>
                                        <Icon icon="heroicons:paper-airplane" className="text-xl" /> Gönder
                                    </>
                                )}
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default BildirimMailGonder;
